import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

declare global {
  interface Window {
    google: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private googleMapsLoaded = false;

  loadGoogleMapsApi(): Promise<any> {
    if (this.googleMapsLoaded) {
      return Promise.resolve(window.google);
    }

    return new Promise((resolve, reject) => {
      if (window.google?.maps) {
        this.googleMapsLoaded = true;
        resolve(window.google);
        return;
      }

      const existingScript = document.querySelector(
        'script[data-google-maps-loader="public-scan"]',
      ) as HTMLScriptElement | null;

      if (existingScript) {
        existingScript.addEventListener('load', () => {
          this.googleMapsLoaded = true;
          resolve(window.google);
        });
        existingScript.addEventListener('error', (error) => reject(error));
        return;
      }

      const script = document.createElement('script');
      script.setAttribute('data-google-maps-loader', 'public-scan');
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}` +
        '&libraries=places,visualization,geometry,marker';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.googleMapsLoaded = true;
        resolve(window.google);
      };
      script.onerror = (error) => reject(error);
      document.body.appendChild(script);
    });
  }
}
